module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/FilterBlue.e4e52924.svg";